import { queryClient } from '@/core/query/query-client';
import { useOnboardingStore } from '@/core/stores/onboarding-store';

// Removes this tab from protected UI when the session ends without user action (a sibling tab's
// logout, or an unrecoverable refresh): guards are loaders, so clearing state alone leaves the
// mounted screen showing the previous user's data. Navigation is injected (the auth layer must
// never import the router) and buffered until a handler registers.
let navigateOut: (() => void) | null = null;
let missedExit = false;

export function setLeaveProtectedUiHandler(handler: () => void): void {
  navigateOut = handler;
  if (missedExit) {
    missedExit = false;
    handler();
  }
}

export async function leaveProtectedUi(): Promise<void> {
  // Exit first, unconditionally: a rejected cancelQueries() must not skip navigation, or the
  // user stays on the protected screen — the exact failure this function exists to prevent.
  if (navigateOut) navigateOut();
  else missedExit = true;

  // The next person to sign in on this tab gets the product tour again, whether the session
  // ended in a sibling tab's logout or in a refresh that could not be recovered.
  useOnboardingStore.getState().forget();

  // Order matters: clear() alone does not cancel in-flight requests, so a response landing
  // afterwards would repopulate the cache with the previous user's data.
  await queryClient.cancelQueries();
  queryClient.clear();
}
